export enum EDutyPhoneTypes {
  DSN = 'DSN',
  COMM = 'COMM'
}
